module.exports = __webpack_public_path__ + "static/media/ICBT 2c3.85b8fb4b.jpg";